import React, { useRef } from 'react';
import { Info, Download, Upload } from 'lucide-react';
import { downloadCsvTemplate } from './csvImportUtils.js';

interface BulkImportDropzoneProps {
  dragActive: boolean;
  onDrag: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const BulkImportDropzone: React.FC<BulkImportDropzoneProps> = ({
  dragActive,
  onDrag,
  onDrop,
  onFileChange,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="space-y-4">
      {/* Instructions and Download Template */}
      <div className="bg-amber-50/60 border border-amber-100/80 rounded-2xl p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <Info className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
          <div className="text-xs text-amber-900">
            <p className="font-semibold">Petunjuk Penggunaan Impor:</p>
            <p className="leading-relaxed text-amber-800/90 mt-0.5">
              Gunakan template resmi untuk kelancaran impor. Kolom yang bertanda bintang seperti Judul Buku, Kategori, dan Tahun Terbit wajib terisi. Format file harus berekstensi <b>.csv</b> dengan pembatas koma.
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={downloadCsvTemplate}
          className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-xl text-xs font-semibold shadow-xs transition flex items-center gap-2 shrink-0 self-stretch sm:self-auto justify-center cursor-pointer"
        >
          <Download className="w-3.5 h-3.5" />
          <span>Unduh Template CSV</span>
        </button>
      </div>

      {/* Drag and Drop Zone */}
      <div
        onDragEnter={onDrag}
        onDragOver={onDrag}
        onDragLeave={onDrag}
        onDrop={onDrop}
        onClick={() => fileInputRef.current?.click()}
        className={`border-2 border-dashed rounded-3xl p-8 text-center flex flex-col items-center justify-center gap-3 transition cursor-pointer ${
          dragActive
            ? 'border-indigo-500 bg-indigo-50/40'
            : 'border-slate-200 hover:border-indigo-400 hover:bg-slate-50/50'
        }`}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv"
          onChange={onFileChange}
          className="hidden"
        />
        <div className="w-12 h-12 rounded-full bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-400 group-hover:text-indigo-500 transition shadow-2xs">
          <Upload className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm font-semibold text-slate-800">Tarik & Lepas File CSV Anda</p>
          <p className="text-xs text-slate-500 mt-1">Atau klik untuk menelusuri berkas dari komputer Anda</p>
        </div>
        <span className="px-2.5 py-1 bg-slate-100 text-slate-600 rounded-md text-[10px] font-medium uppercase tracking-wider mt-1">
          Hanya berkas .csv (Maks. 100 baris)
        </span>
      </div>
    </div>
  );
};
